import { render, staticRenderFns } from "./CardNewsRectangle.vue?vue&type=template&id=30a25658"
import script from "./CardNewsRectangle.vue?vue&type=script&lang=js"
export * from "./CardNewsRectangle.vue?vue&type=script&lang=js"
import style0 from "./CardNewsRectangle.vue?vue&type=style&index=0&id=30a25658&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports